import GaEvent from './GaEvent';

export default class ExternalLinkClickedGaEvent extends GaEvent {
  constructor() {
    super('external_link_clicked');
  }

  addLinkUrl(value: string) {
    this.addParam('link_url', value);

    return this;
  }

  addLinkType(value: string) {
    this.addParam('link_type', value);

    return this;
  }

  addLinkName(value: string) {
    this.addParam('link_name', value);

    return this;
  }
}
